<template>
	<div class="food-tracking">
		<AppHeader></AppHeader>
		<div class="page-wrapper">
			<div class="container-fluid">

				<!-- Title -->
				<div class="row heading-bg">
					<div class="col-xs-12">
						<h5 class="txt-dark pull-left foodTitle">Food Tracking</h5>
						<a style="margin-right:12px;" ref="startMealPlanTrigger" href="#" class="pull-right btn btn-nutri-green btn-size" data-toggle="modal" data-target="#mealPlanModal">Start Diet Plan</a>
						<a style="margin-right:12px;" ref="mealplanButton" href="#" class="pull-right btn btn-nutri-green btn-size" data-toggle="modal" data-target="#removeAllModal">Switch to basic food tracking</a>
					</div>
				</div>
				<!-- /Title -->
				<div class="modal fade" id="removeAllModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
					<div class="modal-dialog" role="document">
						<div class="modal-content">
						<div class="modal-header">
							<h5 class="modal-title" id="exampleModalLabel">Normal Food Tracking</h5>
						</div>
						<div class="modal-body">
							Are you sure you want to switch back to basic food tracking?
						</div>
						<div class="modal-footer">
							<button type="button" class="btn btn-nutri-red" data-dismiss="modal">Cancel</button>
							<button type="button" class="btn btn-nutri-green" data-dismiss="modal" @click="switchDiet()">Okay</button>
						</div>
						</div>
					</div>
				</div>
				<div class="row mb-20">
					<div class="col-xs-12 col-lg-2 date-picker">
						<p style="font-size:12px;">Date</p>
						<Datepicker inputClass="form-control" v-model="date"></Datepicker>
						<!-- <datetime v-model="date" input-id="start-Date" inputClass="form-control" placeholder="Date">
							<template slot="button-cancel-gd">
								<fa :icon="['far', 'times']"></fa>
								Cancel
							</template>
							<template slot="button-confirm-gd">
								<fa :icon="['fas', 'check-circle']"></fa>
								Confirm
							</template>
						</datetime> -->
					</div>
				</div>
				<div class="col-lg-12 .hidden-lg-down">
					<!-- <div id="datepicker" style="">
						<a href="#" @click="(value.getDate() != date.getDate()) ? date = value : null" :data-toggle="(value.getDate() == date.getDate()) ? 'modal' : null"
						:data-target="(value.getDate() == date.getDate()) ? '#datePickerModal' : null" :class="{current_date : (value.getDate() == date.getDate())}"
						class="date col-xs-3" v-for="(value, key) in ribbon_dates" :key="key">
							{{("0" + value.getDate()).slice(-2)}}
							<br/> {{monthNames[value.getMonth()].substr(0,3)}} '{{value.getFullYear().toString().substr(2,2)}}
						</a>
					</div> -->
				</div>
				<div class="mb-5 mt-5 col text-center" v-if="$store.getters.user.meta_data.diet_name">
					<h5>Current meal plan: {{$store.getters.user.meta_data.diet_name}}</h5>
				</div>
				<div class="col-md-12">
					<div class="panel panel-default card-view panel-refresh">
						<div class="refresh-container">
							<div class="la-anim-1"></div>
						</div>
						<div class="panel-heading">
							<div class="pull-left">
								<h4 class="panel-title txt-light">Calories Intake</h4>
							</div>
							<div class="clearfix"></div>
						</div>
						<div v-if="$store.getters.user.meta_data.recommended_intake_calculation == 'standard'" class="panel-wrapper collapse in">
							<div class="panel-body">
								<div class="col-md-3 figure">
									{{food_data.calories_statistics.calories_goal}}
									<br/>
									<span>Goal</span>
								</div>
								<div class="col-md-1 operator">
									-
								</div>
								<div class="col-md-3 figure">
									{{food_data.calories_statistics.calories_consumed}}
									<br/>
									<span>Food</span>
								</div>
								<div class="col-md-2 operator">
									=
								</div>
								<div class="col-md-3 figure result">
									{{food_data.calories_statistics.calories_remaining}}
									<br/>
									<span>Remaining</span>
								</div>
							</div>
						</div>
						<div v-else>
							<div class="panel-body" v-if="food_data.nutrient_totals">
								<div class="col-md-4 text-center">
									<h6 class="title-tag">NET Carbs</h6>
									<div class="progress">
										<div class="progress-bar" role="progressbar" :style="'background:' + $store.getters.user.nutrition_chart_colours[1] + '; width:' + (100 * (food_data.nutrient_totals.net_carbs / $store.getters.user.recommended_intake.total_carbohydrates)) + '%;'" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"></div>
									</div>
									<span class="figure" v-if="$store.getters.user.meta_data.diet_name != 'Standard'">{{food_data.nutrient_totals.net_carbs ? food_data.nutrient_totals.net_carbs.toFixed(0) : 0}}g <span>of {{$store.getters.user.recommended_intake.total_carbohydrates.toFixed(0)}}g</span></span>
									<span class="nutri-font" v-if="$store.getters.user.meta_data.diet_name == 'Standard'">{{food_data.nutrient_totals.net_carbs ? food_data.nutrient_totals.net_carbs.toFixed(0) : 0}}g</span>
								</div>
								<div class="col-md-4 text-center">
									<h6 class="title-tag">Fat</h6>
									<div class="progress">
										<div class="progress-bar" role="progressbar" :style="'background:' + $store.getters.user.nutrition_chart_colours[0] + ';width:' + (100 * (food_data.nutrient_totals.total_fat / $store.getters.user.recommended_intake.total_fat)) + '%;'" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"></div>
									</div>
									<span class="figure" v-if="$store.getters.user.meta_data.diet_name != 'Standard'">{{food_data.nutrient_totals.total_fat ? food_data.nutrient_totals.total_fat.toFixed(0) : 0}}g <span>of {{$store.getters.user.recommended_intake.total_fat.toFixed(0)}}g</span></span>
									<span class="nutri-font" v-if="$store.getters.user.meta_data.diet_name == 'Standard'">{{food_data.nutrient_totals.total_fat ? food_data.nutrient_totals.total_fat.toFixed(0) : 0}}g</span>
								</div>
								<div class="col-md-4 text-center">
									<h6 class="title-tag">Protein</h6>
									<div class="progress">
										<div class="progress-bar" role="progressbar" :style="'background:' + $store.getters.user.nutrition_chart_colours[2] + ';width:' + (100 * (food_data.nutrient_totals.protein / $store.getters.user.recommended_intake.protein)) + '%;'" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100"></div>
									</div>
									<span class="figure" v-if="$store.getters.user.meta_data.diet_name != 'Standard'">{{food_data.nutrient_totals.protein ? food_data.nutrient_totals.protein.toFixed(0) : 0}}g <span>of {{$store.getters.user.recommended_intake.protein.toFixed(0)}}g</span></span>
									<span class="nutri-font" v-if="$store.getters.user.meta_data.diet_name == 'Standard'">{{food_data.nutrient_totals.protein ? food_data.nutrient_totals.protein.toFixed(0) : 0}}g</span>
								</div>
								<!-- <div class="col-md-3 figure">
									{{food_data.calories_statistics.calories_goal}}
									<br/>
									<span>Goal</span>
								</div>
								<div class="col-md-1 operator">
									-
								</div>
								<div class="col-md-3 figure">
									{{food_data.calories_statistics.calories_consumed}}
									<br/>
									<span>Food</span>
								</div>
								<div class="col-md-2 operator">
									=
								</div>
								<div class="col-md-3 figure result">
									{{food_data.calories_statistics.calories_remaining}}
									<br/>
									<span>Remaining</span>
								</div> -->
							</div>
						</div>
					</div>
				</div>
				<div :class="Object.keys(nutrition_data).length != 0 ? 'col-md-6' : 'col-md-12'">
					<Meals :fooddata="food_data" :key="mealsKey"></Meals>
					<button class="btn btn-nutri-green btn-block" @click="addDayToShopping">Add All Ingredients to Shopping Cart</button>
				</div>
				<div class="col-md-6" v-show="Object.keys(nutrition_data).length != 0">
					<div class="panel panel-default card-view panel-refresh">
						<div class="refresh-container">
							<div class="la-anim-1"></div>
						</div>
						<div class="panel-heading">
							<div class="pull-left">
								<h4 class="panel-title txt-light">Nutritional Information</h4>
							</div>
							<div class="clearfix"></div>
						</div>
						<div class="panel-wrapper collapse in">
							<div class="panel-body">
								<h5 class="text-center mg-b-30">Nutritional Information</h5>
								<pie-chart :data="nutrition_data" :colors="$store.getters.user.nutrition_chart_colours" legend="bottom"></pie-chart>
							</div>
							<div class="panel-body">
								<div v-for="(item, index) in food_data.nutrient_totals" v-bind:key="index">
									<span class="pull-left inline-block capitalize-font txt-dark">
										{{index.replace(/_/g, ' ')}}
									</span>
									<span v-if="index == 'energy_kj'" class="pull-right text-right">{{(item / 4.184).toFixed(0)}} {{$store.getters.user.recommended_intake_units[index]}}</span>
									<span v-else class="pull-right text-right">{{item.toFixed(0)}} {{$store.getters.user.recommended_intake_units[index]}}</span>
									<div class="clearfix"></div>
									<hr class="light-grey-hr row mt-10 mb-10">
								</div>
							</div>
						</div>
					</div>
				</div>
				<AppFooter></AppFooter>
			</div>
		</div>

<!-- Meal Plan Modal -->
    <div id="mealPlanModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <div class="modal-header-icon">
              <img src="dist/img/diet.jpg" alt="scale">
              <h4>Start Diet Plan</h4>
              <br/>
              <br/>
              <form class="form-horizontal">
                <div class="form-group">
                  <label for="goal" class="col-sm-3 control-label">Meal Plan</label>
                  <div class="col-sm-8">
                    <select :disabled="!$store.getters.user.vip_user" name="" class="form-control" id="" v-model="newMealPlan">
                      <option :value="mealplan" v-for="(mealplan, key) in available_mealplans" :key="key">{{mealplan.name}}</option>
                    </select>
                  </div>
                  <div class="col-sm-1">
                    <a v-if="newMealPlan" href="#" class="info" data-toggle="modal" data-target="#infoModal">
                      <i class="fa fa-info-circle info-btn"></i>
                    </a>
                  </div>
                </div>
                <div class="form-group">
                  <label for="goal" class="col-sm-3 control-label">Starting Date</label>
                  <div class="col-sm-8">
                    <Datepicker inputClass="form-control" v-model="newMealPlanDate"></Datepicker>
                   </div>
                </div>
              </form>
              <p v-if="!$store.getters.user.vip_user">You need to be a VIP to start a meal plan. Check out our VIP benefits right <a style="color:#8BC34A" href="#" data-dismiss="modal" @click="$router.push('/profile/upgrade')">here</a>!</p>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-nutri-red" data-dismiss="modal" ref="newMealPlanClose">Close</button>
            <button type="button" class="btn btn-nutri-green" v-if="$store.getters.user.vip_user" @click="startMealPlan" data-dismiss="modal">Start Mealplan</button>
          </div>
        </div>
      </div>
    </div>
    <!-- Meal Modal End -->

    <!-- Meal Plan Modal -->
    <div id="infoModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <div class="modal-header-icon">
              <img src="dist/img/diet.jpg" alt="scale">
              <h4 v-if="newMealPlan">{{newMealPlan.name}}</h4>
              <br/>
              <br/>
              <p v-if="newMealPlan" style="text-align: justify; padding: 0 50px;">
                {{newMealPlan.description}}
              </p>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-nutri-green" data-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>
    <!-- Meal Modal End -->

		<!-- Weight Settings Modal -->
		<div id="datePickerModal" ref="datePickerModal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"
		   aria-hidden="true">
			<div class="modal-dialog">
				<div class="modal-content">
					<div class="modal-body" style="text-align:center">
						<datepicker v-model="date" :inline="true" calendar-class="nutrivitas-datepicker"></datepicker>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-info" data-dismiss="modal" ref="pickDateClose">Close</button>
					</div>
				</div>
				<!-- /.modal-content -->
			</div>
			<!-- /.modal-dialog -->
		</div>
		<!-- /.modal -->
		<loading :active.sync="isLoading"></loading>

	</div>
</template>

<script>
import API from "../../services/api.js";
import AppHeader from '../../components/common/AppHeader.vue'
import AppFooter from '../../components/common/AppFooter.vue'
import Datepicker from 'vuejs-datepicker';
import Meals from './components/Meals.vue';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { Datetime } from 'vue-datetime'
import 'vue-datetime/dist/vue-datetime.css'

const api = new API();

var store = this.$store;
export default {
	components: {
		AppHeader,
		AppFooter,
		Meals,
		Loading,
		Datetime,
		Datepicker,
	},
	data() {
		return {
			isLoading: false,
			trackings: null,
			date: this.$store.getters.globalDate,
			food_data: {
				"calories_statistics": {
					"calories_burnt" : 0,
					"calories_consumed" : 0,
					"calories_goal" : 0,
					"calories_remaining" : 0,
					"percentage_consumed" : 0,
				}
			},
			available_mealplans: null,
			newMealPlanDate: null,
			newMealPlan: null,
			ribbon_dates: [],
			monthNames: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
			nutrition_data:{},
			food_loaded:false,
			mealsKey: "meals_key_" + Math.random(0,100)
		}
	},
	mounted(){
		if(this.$route.query.meal == 1){
			const elem = this.$refs.mealplanButton;
			elem.click();
			this.$router.replace('/food-tracker');
		}
	},
	methods: {
		switchDiet(){
			let profile = {
				"recommended_intake_calculation" : 'standard',
			};
			api.updateProfile(profile).then(async response =>{
				if(response.data.success){
					swal("Account Updated!", "You switch back to the standard diet.", "success");
					api.me();
					this.getFoodsForToday();
					setTimeout(() => {
						swal.close();
					}, 4000);
				}
			});
		},
		getFoodsForToday() {
			this.isLoading = true;
			api.me();
			api.getFoodsByDate(this.date).then(async response => {
				if (response.data.success) {
					this.food_data = response.data.data;
					this.nutrition_data = {};
					this.nutrition_data['Fats'] = 0;
					this.nutrition_data['Carbs'] = 0;
					this.nutrition_data['Protein'] = 0;
					for(var m in this.food_data.meals){
						//As Requested by him we will not show calories
						// if(this.food_data["nutrient_" + m].calories != null) {
						// 	this.nutrition_data['Calories'] = this.nutrition_data['Calories'] + this.food_data["nutrient_" + m].calories;
						// }
						if(this.food_data["nutrient_" + m].carbohydrates_available != null) {
							this.nutrition_data['Carbs'] = this.nutrition_data['Carbs'] + this.food_data["nutrient_" + m].carbohydrates_available;
						}
						if(this.food_data["nutrient_" + m].protein != null) {
							this.nutrition_data['Protein'] = this.nutrition_data['Protein'] + this.food_data["nutrient_" + m].protein;
						}
						if(this.food_data["nutrient_" + m].total_fat != null) {
							this.nutrition_data['Fats'] = this.nutrition_data['Fats'] + this.food_data["nutrient_" + m].total_fat;
						}
					}
					this.food_loaded = true;
					this.mealsKey = "meals_key_" + Math.random(0,100);
					//As Requested by him we will not show calories
					// this.nutrition_data['Calories'] = this.nutrition_data['Calories'].toFixed(0);
					this.nutrition_data['Fats'] = this.nutrition_data['Fats'].toFixed(0);
					this.nutrition_data['Carbs'] = this.nutrition_data['Carbs'].toFixed(0);
					this.nutrition_data['Protein'] = this.nutrition_data['Protein'].toFixed(0);
					this.isLoading = false;
				}
			});
		},
		getAvailableMealPlans(){
			api.getAvailableMealPlans(this.date).then(async response => {
				if (response.data.success) {
					this.available_mealplans  = response.data.data;
				}
			});
		},
		startMealPlan(){
			this.isLoading = true;
			api.startMealPlan(this.newMealPlan.id, this.newMealPlanDate || new Date()).then(async response => {
				if (response.data.success) {
					this.isLoading = false;
					const elem = this.$refs.newMealPlanClose;
					elem.click();
					swal("Mealplan Started!", "Your mealplan has been recorded!", "success");
					setTimeout(() => {
						swal.close();
					}, 4000);

					this.getFoodsForToday();
					api.me();
				}
			});
		},
		setDatesArrays(){
			this.ribbon_dates = [];
			for(var j = 3; j >= 1; j--){
				var d = new Date(this.date);
				this.ribbon_dates.push(new Date(d.setDate(d.getDate() - j)));
			}

			this.ribbon_dates.push(new Date(this.date));

			for(var j = 1; j <= 3; j++){
				var d = new Date(this.date);
				this.ribbon_dates.push(new Date(d.setDate(d.getDate() + j)));
			}
		},
		addDayToShopping(){
			let d = this.date;
			api.addDayToShopping(d).then(async response => {
				if (response.data.success) {
					swal("Ingredients Added!", "Ingredients for this day have been added to the shopping list!", "success");
					setTimeout(() => {
						swal.close();
					}, 4000);
				}
			});
		}
	},
	created: function () {
		this.getFoodsForToday();
		this.getAvailableMealPlans();
		this.setDatesArrays();
		this.date = this.$store.getters.globalDate;
	},
	mounted: function() {
		if(this.$route.query.smp) {
			//Trigger mealplan modal
			this.$refs.startMealPlanTrigger.click();
		}
	},
	watch: {
		'date': function () {
			this.getFoodsForToday();
			this.setDatesArrays();
			this.$store.commit('updateGlobalDate', this.date);
		}
	}
}

Number.prototype.pad = function(size) {
  var s = String(this);
  while (s.length < (size || 2)) {s = "0" + s;}
  return s;
}
</script>


<style scoped>
	.nutri-font{
		font-weight: bold;
		color: black;
	}

	.btn-size{
		width: 250px;
	}

	.title-tag{
		text-align: center;
		margin-bottom: 4px;
	}

	.date-picker{
		margin-left:10px;
	}

	.trash{
		color: rgba(204,0,0,0.5);
	}

	.trash:hover{
		color: rgba(204,0,0,1);
	}

	.figure{
		text-align: center;
		font-size: 20px;
		font-weight: bold;
	}

	.figure span{
		font-size:12px;
		font-weight: lighter;
	}

	.operator{
		font-weight: bold;
		font-size: 20px;
		text-align: center;
	}

	.foodTitle{
		margin-left: 29px;
	}
	
	b{
		font-weight: bold;
		font-size: 1.4rem;
	}
</style>



// WEBPACK FOOTER //
// src/views/FoodTracking/FoodTracking.vue